import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">专题合集</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">按频道浏览全部影视内容，找到你的专属观影频道</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group flex flex-col items-center bg-background-100 rounded-xl p-6 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer text-center"
            >
              <div className="w-16 h-16 rounded-2xl bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors duration-200">
                <i className={`${item.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-base font-heading text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-3">{item.desc}</p>
              <span className="text-xs font-medium text-primary-600 bg-primary-50 px-3 py-1 rounded-full whitespace-nowrap">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}